'use strict';

var BOSHConnection = require('../transports/bosh');


module.exports = function (client) {

    client.transports.bosh = BOSHConnection;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/stanza.io/lib/plugins/bosh.js
// module id = 286
// module chunks = 0